<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>{{ dispTitle }}</h1>

<mat-card class="cur-card">
    <mat-card-content>
        <form [formGroup]="parentForm">
            <app-sgkb941d-wt-contract-change (titleChange)="onTitleChange($event)" (setMessageEvent)="pushSgAriaMessage($event)">
            </app-sgkb941d-wt-contract-change>
        </form>
    </mat-card-content>
</mat-card>